import { PageLayout } from '../components/Layout/PageLayout';
import { SquareGame } from '../components/SquareGame/SquareGame';
import { SquareHero } from '../components/SquareGame/SquareHero';

export function SquaresPage() {
  return (
    <PageLayout
      hero={<SquareHero />}
      game={<SquareGame />}
    />
  );
}